import React from 'react';
import { Space, Tag, Tooltip, Typography } from 'antd';
import { GlobalOutlined } from '@ant-design/icons';
import { F } from '@/utils/intl';

/**
 * Working hours / additional availability are wall-clock strings that apply in
 * the local time of the branch the person is booked in. These renderers make
 * that timezone visible wherever the availability itself is shown; both render
 * nothing when the person serves no branch (see getAgentBranchTimezones).
 */
export const AvailabilityTimezoneTag = ({ timezones }: { timezones: string[] }) => {
  if (!timezones.length) return null;
  return (
    <Tooltip
      title={
        <F
          id={'pages.users.availabilityTimezone.tooltip'}
          defaultMessage={'Working hours and additional availability apply in the local time of the branch.'}
        />
      }
    >
      <Tag bordered={false} icon={<GlobalOutlined />} style={{ marginRight: 0 }}>
        {timezones.join(', ')}
      </Tag>
    </Tooltip>
  );
};

export const AvailabilityTimezoneHint = ({ timezones }: { timezones: string[] }) => {
  if (!timezones.length) return null;
  return (
    <Typography.Text type={'secondary'}>
      <small>
        <Space size={4}>
          <GlobalOutlined />
          <F
            id={'pages.users.availabilityTimezone.hint'}
            defaultMessage={"Times apply in the branch's local time: {timezones}"}
            values={{ timezones: timezones.join(', ') }}
          />
        </Space>
      </small>
    </Typography.Text>
  );
};
